import popMgr from '@/components/global/popMgr';
import pop from './index.vue';
export default function() {
    popMgr.create(pop);
}